export const OPEN_CSV_UPLOAD = 'OPEN_CSV_UPLOAD'

export default () => ({
  type: OPEN_CSV_UPLOAD,
})
